<template>
  <div id="update-card">
    <v-card>
      <v-img
        class="white--text"
        height="300px"
        :src="update.img"
        gradient="to bottom, rgba(0,0,0,.8), rgba(0,0,0,0)"
      >
        <v-container fill-height>
          <v-layout fill-height>
            <!-- <v-flex xs12 align-end flexbox> -->
              <v-flex align-end flexbox>
              <span class="headline">{{ update.title }}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-img>
      <v-card-actions style="background-color:teal;">
        <v-avatar size="36px">
          <img :src="update.avatar">
        </v-avatar>
        <b>&nbsp; {{ update.user }}</b>
        <v-spacer></v-spacer>
        <p class="grey--text text--lighten-2 text-xs-right">Posted: {{ update.date }}</p>
      </v-card-actions>
      <v-card-text>
          <p>{{ update.body }}</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },

  props: [
    `update`
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/cards/UpdateCard.vue